import { render } from "./LayoutDefault.vue?vue&type=template&id=0e0639e4&scoped=true"
import script from "./LayoutDefault.vue?vue&type=script&lang=js"
export * from "./LayoutDefault.vue?vue&type=script&lang=js"

import "./LayoutDefault.vue?vue&type=style&index=0&id=0e0639e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0639e4"]])

export default __exports__